import { render, staticRenderFns } from "./BetterAuthLogin.vue?vue&type=template&id=0db25774&scoped=true&"
import script from "./BetterAuthLogin.vue?vue&type=script&lang=js&"
export * from "./BetterAuthLogin.vue?vue&type=script&lang=js&"
import style0 from "./BetterAuthLogin.vue?vue&type=style&index=0&id=0db25774&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db25774",
  null
  
)

export default component.exports